import { render } from "./ValidationMessage.vue?vue&type=template&id=3ba4a7d4&scoped=true"
import script from "./ValidationMessage.vue?vue&type=script&lang=js"
export * from "./ValidationMessage.vue?vue&type=script&lang=js"

import "./ValidationMessage.vue?vue&type=style&index=0&id=3ba4a7d4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba4a7d4"]])

export default __exports__